export interface SavedDropdownOption {
  label: string;
  value: string | number;
  persistentName?: string | null;
}

function getSavedValue(ruleTypeParamsId?: string): string | undefined {
  if (!ruleTypeParamsId) return undefined;

  const separatorIndex = ruleTypeParamsId.indexOf('=');
  return (separatorIndex >= 0 ? ruleTypeParamsId.slice(separatorIndex + 1) : ruleTypeParamsId).trim() || undefined;
}

export function resolveSavedDropdownOption<T extends SavedDropdownOption>(
  options: T[],
  persistentName?: string,
  ruleTypeParamsId?: string
): T | undefined {
  const savedValue = getSavedValue(ruleTypeParamsId);
  return (
    options.find((option) => savedValue !== undefined && String(option.value) === savedValue) ??
    options.find((option) => option.persistentName === persistentName)
  );
}
